const PROJECT_LIST = [
  {
    name: "Gifos",
    links: [
      "https://github.com/DannyCarvajal/gifos",
      "https://dannycarvajal.github.io/gifos/",
    ],
    description:
      "Developed a platform to explore, create and download GIFs. You can store your favorite GIFs, see trending topics and trending GIFs, and turn the dark mode on. Powered by Giphy’s API and WebRTC library",
  },
  {
    name: "Relyer",
    links: [
      "https://github.com/DannyCarvajal/relyer",
      "https://dannycarvajal.github.io/relyer/",
      "https://www.behance.net/gallery/129632115/RELYER",
    ],
    description:
      "Took part as main Front-End developer and UX/UI designer in the development of Relyer. A platform that helps MSMEs identify their tech needs, connecting with suppliers and experts that will boost their companies. We do a diagnosis test and then we suggest specialists and tools according to their needs",
  },
  {
    name: "Podcast Channel",
    links: [
      "https://github.com/DannyCarvajal/podcastchannel",
      "https://dannycarvajal.github.io/podcastchannel",
    ],
    description:
      "Developed Podcast channel, a platform that allows you to listen to different podcasts related to tech by using embedded podcasts from Spotify, enjoy listening...”",
  },
  {
    name: "Delilah Resto",
    links: ["https://github.com/DannyCarvajal/DelilahResto"],
    description:
      "Created a REST API for a restaurant business 🥘 in which the clients (users) can register and order the most deluxe plates. The administrator can manage the orders, the plates and the users of the API",
  },
];

export default PROJECT_LIST;
